const allReferencesItems = document.querySelectorAll('.references-all__item')
const modal = document.querySelector('.references-all__modal')

const showModal = e => {
	modal.style.display = 'block'

	let zoomedImg = document.createElement('img')
	let srcAttribute = e.target.getAttribute('src')

	zoomedImg.setAttribute('src', srcAttribute)
	zoomedImg.classList.add('references-all__modal-img')
	modal.append(zoomedImg)
}

allReferencesItems.forEach(item => {
	item.addEventListener('click', showModal)
})

modal.addEventListener('click', () => {
	modal.style.display = 'none'
	modal.innerHTML = ''
})